import './App.css';
import React from 'react';
import Auth from 'Auth';

function App() {
    return (
        <div className="App">
            <Auth />
        </div>
    );
}

export default App;
